import { getRouteApi, useNavigate } from '@tanstack/react-router';
import * as React from 'react';

import { CampaignMonitoringScreen } from '@/routes/admin/campaigns/campaign-monitoring-screen';

// =============================================================================
// campaign-monitoring-route.tsx — Adaptateur routeur du « Suivi de campagne temps réel » (§2.5, A4).
// =============================================================================
// L'id de campagne est le path param d'URL (« /admin/campaigns/$campaignId/monitoring ») — ressource
// d'URL, cohérent avec le contrat API (campaignId server-set, invariant n°1). Le client operational-view
// vient du contexte global (DÉFAUT = HTTP réel) : aucun provider local nécessaire (garde 09). Le composant
// de présentation reste testable hors routeur.

const routeApi = getRouteApi('/admin/campaigns/$campaignId/monitoring');

export function CampaignMonitoringRoute(): React.JSX.Element {
  const { campaignId } = routeApi.useParams();
  const navigate = useNavigate();

  const onViewOperational = React.useCallback((): void => {
    void navigate({
      to: '/admin/campaigns/$campaignId/operational-view/profils',
      params: { campaignId },
    });
  }, [navigate, campaignId]);

  return (
    <CampaignMonitoringScreen
      campaignId={campaignId}
      onViewOperational={onViewOperational}
    />
  );
}
